import React, { useState } from 'react';
import { Summary } from './summary';
import { FaLongArrowAltRight } from 'react-icons/fa';
import { ContactModal } from '../ContactModal';
import { Accordion } from './accordion';
import './Summary.css';

export const Solarwinds = () => {
  const [showContactModal, setShowContactModal] = useState(false);

  const handleRequestDemo = () => {
    setShowContactModal(true);
  };

  const handleCloseContactModal = () => {
    setShowContactModal(false);
  };
  return (
    <>   
      <h1 className="solarwinds-main-title">SOLARWINDS</h1>
      <Summary />
      <h2 className="solarwinds-feature-title">Feature solution</h2>
      <Accordion />

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <button className="custom-button" onClick={handleRequestDemo}>
          <span>
          Request Details <FaLongArrowAltRight />
          </span>
        </button>
    
      <ContactModal style={{zIndex:"100090"}} showModal={showContactModal} onClose={handleCloseContactModal} />
      </div>
    </>
  );
};